export default __webpack_public_path__ + "static/media/landing-video.5b533d1b.webm";